import React from "react";
import { Form, Col } from "react-bootstrap";

export default function PlaylistPerspectivePicker({ formData, setFormData, name, playlistPerspectives, includeCustom = true }) {
    return (
        <Form.Group as={Col} controlId={`${name}-playlist-perspective`} className="col-12 col-xl-1 min-w-perspective">
            <Form.Label>Perspective</Form.Label>
            <Form.Select
                value={
                    playlistPerspectives.find(x => JSON.stringify(x.categories.map(cg => cg.code)) === formData.playlistPerspective)
                        ? formData.playlistPerspective
                        : "custom"
                }
                onChange={e => setFormData({ ...formData, playlistPerspective: e.target.value })}>
                {playlistPerspectives.map(x => (
                    <option key={x.perspective} value={JSON.stringify(x.categories.map(cg => cg.code))}>
                        {x.perspective}
                    </option>
                ))}
                {includeCustom && <option value={"custom"}>Custom</option>}
            </Form.Select>
        </Form.Group>
    );
}
